module.exports = __webpack_public_path__ + "static/img/基因调控.be9916e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/一级标题Banner/基因调控.jpg
// module id = kLqB
// module chunks = 1